import { render, staticRenderFns } from "./JsonEditDialog.vue?vue&type=template&id=523e80d2&scoped=true"
import script from "./JsonEditDialog.vue?vue&type=script&lang=js"
export * from "./JsonEditDialog.vue?vue&type=script&lang=js"
import style0 from "./JsonEditDialog.vue?vue&type=style&index=0&id=523e80d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "523e80d2",
  null
  
)

export default component.exports